import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'react-css-themr';
import { Card, CardMedia, CardText, CardActions } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { signInGoogleUser, signInMicrosoftUser, loginUserFailure } from '../../shared/actionCreators';
import logoImg from '../../assets/images/sp-logo.svg';
import login from './login.scss';
import MicrosoftLoginButton from './azure/MicrosoftLoginButton';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLoginButton from '../../shared/components/Auth/googleLoginButton';

const DEFAULT_REDIRECT_PATH = '/';
const cpText = `Copyright ${new Date().getFullYear()}. All rights reserved`;
const theme = { RTCard: login };

const searchIdToken = (data) => {
  if ({}.hasOwnProperty.call(data, 'id_token')) return data.id_token;
  let token = null;
  Object.keys(data).forEach(((key) => {
    token = token || (typeof (data[key]) === 'object' && searchIdToken(data[key]));
  }));
  return token;
};

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.handleGoogleResponse = this.handleGoogleResponse.bind(this);
  }

  componentWillMount = () => {
    const { isAuthenticated, replace, redirect } = this.props;
    if (isAuthenticated) replace(redirect);
  }

  componentWillReceiveProps = (nextProps) => {
    const { isAuthenticated, replace, redirect } = nextProps;
    const { isAuthenticated: wasAuthenticated } = this.props;
    if (!wasAuthenticated && isAuthenticated) replace(redirect);
  }

  onMicrosoftAuthenticated = (data, msal) => {
    this.handleMicrosoftError('');
    this.props.signInMicrosoftUser({
      id_token: data.idToken,
      uid_type: 'microsoft',
    }, msal);
  }

  handleGoogleResponse = response => this.props.signInGoogleUser({
    code: response.code, uid_type: 'google',
  });

  handleGoogleError = response => this.props.loginUserFailure(response.error);

  handleMicrosoftError = err => this.props.loginUserFailure(err);

  render = () => {
    const hasLoginError = this.props.statusText != null;
    return (<div className={login.loginWrapper}>
      <ThemeProvider theme={theme}>
        <Card>
          <CardMedia>
            <img className={login.spLogo} alt="Service Pros logo" src={logoImg} />
          </CardMedia>
          {hasLoginError ? (<CardText>{this.props.statusText}</CardText>) : null}
          <CardActions>
            <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID_AUTH}>
              <GoogleLoginButton handleGoogleResponse={this.handleGoogleResponse} />
            </GoogleOAuthProvider>
          </CardActions>
          <CardActions>
            <MicrosoftLoginButton
              onAuthenticated={this.onMicrosoftAuthenticated}
              onError={this.handleMicrosoftError}
            />
          </CardActions>
        </Card>
      </ThemeProvider>
      <div className={login.copyright}>{cpText}</div>
    </div>);
  }
}

const mapStateToProps = (state, ownProps) => ({
  statusText: state.user.statusText,
  isAuthenticated: state.user.isAuthenticated,
  wasAuthenticated: ownProps.isAuthenticated,
  redirect: ownProps.location.query.redirect || DEFAULT_REDIRECT_PATH,
});

Login.propTypes = {
  replace: PropTypes.func,
  signInGoogleUser: PropTypes.func,
  signInMicrosoftUser: PropTypes.func,
  loginUserFailure: PropTypes.func,
  redirect: PropTypes.string,
  statusText: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  wasAuthenticated: PropTypes.bool,
};

export default connect(mapStateToProps, {
  signInGoogleUser,
  signInMicrosoftUser,
  loginUserFailure,
  replace: routerActions.replace,
})(Login);



// WEBPACK FOOTER //
// ./client/app/screens/login/index.jsx